import { render } from "./Register.vue?vue&type=template&id=1e6252f2&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=1e6252f2&scoped=true&lang=css"

import exportComponent from "/home/jk/htdocs/vue/mlcc/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6252f2"]])

export default __exports__